import React, { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { images } from "../../Assets/images";

const Password = () => {
  const {
    showPasswords,
    togglePassword,
    updateUserData,
    userData,
    loginByPassword,
    handlenavigateToEmail,
    translatedLabels,
    logoUrl,
  } = useContext(GlobalContext);
  const authLabel = translatedLabels?.auth;

  const handleSubmit = (e) => {
    e.preventDefault();
    loginByPassword();
  };
  return (
    <>
      <section id="forgotPasswordPage" className="login-section-bg">
        <div className="container-main justify-content-center">
          <div className="text-center">
            <h4 className="text-white mx-2">
              <div className="d-flex justify-content-center">
                <div className="app-logo">
                  <img
                    src={logoUrl || images.appLogo}
                    alt="app-logo"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = images.appLogo;
                    }}
                  />
                </div>
              </div>
            </h4>
          </div>
          <h3 className="mt-3 mb-0 text-center">
            {authLabel?.password?.label_value || "Password"}
          </h3>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="position-relative">
              <label className="form-label">
                {authLabel?.password?.label_value || "Password"}
              </label>
              <input
                type={showPasswords.field1 ? "text" : "password"}
                name="password1"
                className="form-control wrInputText"
                placeholder={
                  authLabel?.enter_password?.label_value || "Enter Password"
                }
                required
                value={userData.password}
                onChange={(e) => updateUserData("password", e.target.value)}
              />
              <span
                className="toggle-password position-absolute eye-icon"
                onClick={() => togglePassword("field1")}
              >
                <i
                  className={`fa ${showPasswords.field1 ? "fa-eye" : "fa-eye-slash"
                    }`}
                ></i>
              </span>
            </div>

            <div className="d-flex justify-content-end mt-2">
              <button
                type="button"
                onClick={handlenavigateToEmail}
                className="nav-link text-decoration-underline text-primary fw-medium"
              >
                {authLabel?.forgot_password_q?.label_value ||
                  "Forgot Password?"}
              </button>
            </div>

            <div className="mt-5 text-center">
              <button className="btn btn-primary">
                {authLabel?.login?.label_value || "Login"}
              </button>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default Password;
